<template>
  <b-nav-item-dropdown
    v-if="!$store.getters['auth/isAuthenticated'] && languages"
    right
    no-caret
    menu-class="position-absolute p-1"
    toggle-class="my-auto btn"
    class="w-100 dropdown-menu-lg pb-0"
  >
    <template #button-content v-if="defaultLanguage.code">
      <lang-flag :iso="defaultLanguage.code" :squared="false" class="mr-2 lx ml-auto"/>
    </template>

    <template v-for="lang in languages">

      <b-dropdown-item @click="updateLangue(lang)">
        <lang-flag :iso="lang.code" :squared="false" class="mr-2 lx ml-auto"/>
        {{lang.name}}
      </b-dropdown-item>
    </template>
  </b-nav-item-dropdown>
</template>

<script>
import {getAllLanguagesForConnectedScope} from "../../../api/languages.api";

export default {
  name: "LanguagesMultiselect",
  data() {
    return {
      languages: [],
      defaultLanguage: {code: null,
                        name: null}
    }
  },
  created() {
    if(!this.$store.getters['auth/isAuthenticated']) {
      this.getAllLanguages();
    }
  },
  methods: {
    getAllLanguages() {
      getAllLanguagesForConnectedScope().then(
        (response) => {
          this.languages = response.data;
          this.updateLangue(this.languages.find(element => element.isDefault === true));
          this.$store.dispatch("scope/changeScopeLanguagesStatus", true);

        },
        (error) => {
          this.handleApiError(error);
        }
      )
    },
    updateLangue(lang) {
      this.defaultLanguage = lang;
      this.$i18n.locale = this.defaultLanguage.code;
    }
  }
}
</script>

<style scoped>

</style>
